import React from "react";

export default function ContextState({ available, children, darkMode = false }) {
  if (available) return <>{children}</>;
  return <span data-testid="context-unavailable" style={{ color: darkMode ? "#94A3B8" : "#64748B", fontWeight: 700 }}>Context unavailable.</span>;
}
